export const RECEIVED_CURRENT_TEAM = 'RECEIVED_CURRENT_TEAM';

const getCurrentTeam = () => (
  (dispatch) => {
    const { teamMarket } = window;
    let { team } = window;

    team = Object.assign({}, team, {
      market: teamMarket,
    });

    dispatch({
      type: RECEIVED_CURRENT_TEAM,
      team,
    });

    return team;
  }
);

export default getCurrentTeam;
